import React from 'react'
import { Card, CardBody, Container } from "reactstrap"
import CurrencyFormat from 'react-currency-format'
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty, head } from 'lodash'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'
import SummaryCard from '../Cards/Summary'
import orderConfirmedImg from '../../../assets/images/orders/orderconfirmed-logo.png'
import orderEnvioImg from '../../../assets/images/orders/envio.png'

moment.locale('es')

const OrderConfirmedView = ({
  cart,
  settings,
  paymentMethods,
  orderConfirmed,
  user,
  paymentType,
  oxxoResponse,
}) => {
  return (
    <div>
      <Container>
        <div className="text-right">
          <label style={{ color: 'grey', fontSize: '18px' }}>
            Pedido #{!isEmpty(orderConfirmed) ? orderConfirmed.folio : ''}
          </label>
        </div>
        <Card className="text-center">
          <CardBody>
            <img
              src={orderConfirmedImg}
              alt="Pedido confirmado"
              className="img-fluid mx-auto d-block"
              width="240px"
              height="111px"
              style={{ marginBottom: '10px' }}
            />
            <p style={{ fontSize: '16px' }}>
              Felicidades por tu pedido
            </p>
            <p>
              En Vendora nos hace felices ayudarte a tener un negocio exitoso.
            </p>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div
              className="font-weight-bold"
              style={{ marginBottom: '10px' }}
            >
              <label className="font-weight-bold" style={{ fontSize: '18px' }}>Detalles del Pedido</label>
            </div>
            <div>
              <label className="font-weight-bold">
                Fecha de compra
              </label>
              <div>
                {
                  !isEmpty(orderConfirmed) ?
                    ` ${moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').format('DD MMMM YYYY hh:mm A')}`
                    :
                    ''
                }
              </div>
            </div>
            {
              !isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PENDIENTE_DE_PAGO' && (
                <span>
                  <div style={{ marginTop: '10px' }}>
                    <label className="font-weight-bold">
                      Fecha limite de pago:
                    </label>
                    <p>
                      {moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').add(1, 'day').format('DD MMMM YYYY hh:mm A')}
                    </p>
                  </div>
                  <p style={{ marginBottom: '5px' }}>
                    Recuerda que tienes 24 horas para hacer tu pago.
                  </p>
                  {
                    paymentType === 'DEPOSITO' && !isEmpty(paymentMethods) && paymentMethods.map(pay => (
                      <div key={`pm_${pay.id}`}>
                        <div>
                          <label className="font-weight-bold">
                            Método de pago:
                          </label> {' '}
                          <label className="font-weight-bold" style={{ color: 'green' }}>
                            {pay.name}
                          </label>
                        </div>
                        <div>
                          {pay.accountPrefix}
                        </div>
                        <div>
                          {pay.accountNumber}
                        </div>
                        <div>
                          {pay.entityName}
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          {pay.ownerName}
                        </div>
                      </div>
                    ))
                  }
                  {
                    paymentType === 'OXXO' && !isEmpty(oxxoResponse) && (
                      <div>
                        <div style={{ marginTop: '10px' }}>
                          <div>
                            <label className="font-weight-bold">
                              Método de pago:
                            </label> {' '}
                            <label className="font-weight-bold" style={{ color: 'green' }}>
                              Oxxo
                            </label>
                          </div>
                          <div>
                            <label className="font-weight-bold">
                              Monto a pagar:
                            </label> {' '}
                            <label style={{ fontSize: '18px' }}>
                                <CurrencyFormat
                                  value={oxxoResponse.amount / 100}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                                <sup>{oxxoResponse.currency}</sup>
                            </label>
                            <div style={{ fontSize: '10px' }}>
                              <p>OXXO cobrará una comisión adicional al momento de realizar el pago.</p>
                            </div>
                          </div>

                          <div>
                            <label className="font-weight-bold">Referencia</label>
                            <h4
                              style={{
                                color: '#000000',
                                textAlign: 'center',
                                marginTop: '-1px',
                                padding: '6px 0 7px',
                                border: '1px solid #b0afb5',
                                borderRadius: '4px',
                                background: '#f8f9fa',
                              }}
                            >
                              {oxxoResponse.charges.data[0].payment_method.reference}
                            </h4>
                          </div>
                        </div>
                        <div>
                          <label className="font-weight-bold">Instrucciones</label>
                          <ol>
                            <li style={{ marginTop: '10px', color: '#000000' }}>Acude a la tienda OXXO más cercana. <a style={{ color: '#1155cc' }} href="https://www.google.com.mx/maps/search/oxxo/" target="_blank" rel="noopener noreferrer">Encuéntrala aquí</a>.</li>
                            <li style={{ marginTop: '10px', color: '#000000' }}>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li>
                            <li style={{ marginTop: '10px', color: '#000000' }}>Dicta al cajero el número de referencia en esta ficha para que tecleé directamete en la pantalla de venta.</li>
                            <li style={{ marginTop: '10px', color: '#000000' }}>Realiza el pago correspondiente con dinero en efectivo.</li>
                            <li style={{ marginTop: '10px', color: '#000000' }}>Al confirmar tu pago, el cajero te entregará un comprobante impreso. <strong>En el podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de pago.</li>
                          </ol>
                          <div className="opps-footnote">Al completar estos pasos recibirás un correo de <strong>Vendora</strong> confirmando tu pago.</div>
                        </div>
                      </div>
                    )
                  }
                </span>
              )
            }
            {!isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PAGADO' && (
              <div style={{ marginTop: '10px' }}>
                <label className="font-weight-bold">
                  Método de pago:
                </label> {' '}
                <label className="font-weight-bold" style={{ color: 'green' }}>
                  {orderConfirmed.paymentType === 'card' ? ' Pago en línea' : 'Transferencia / Depósito'}
                </label>
              </div>
            )}
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <img
                src={orderEnvioImg}
                alt="Dirección de envío"
                className="img-fluid mx-auto d-block"
                width="240px"
                height="111px"
                style={{ marginBottom: '20px' }}
            />
            <div
              className="font-weight-bold"
              style={{ marginBottom: '20px' }}
            >
              <label style={{ fontSize: '16px', color: '#e52e6a' }}>DIRECCIÓN DE ENVÍO</label>
            </div>
            <div>
              <label className="font-weight-bold">
                {!isEmpty(user) ? user.firstName : ''} {!isEmpty(user) ? user.lastName : ''}
              </label>
            </div>
            <div style={{ fontSize: '12px', marginBottom: '10px' }}>
              {!isEmpty(orderConfirmed) && (`
                  ${orderConfirmed.userAddress.calle} 
                  ${orderConfirmed.userAddress.numeroExterior} 
                  ${orderConfirmed.userAddress.numeroInterior} 
                  ${orderConfirmed.userAddress.colonia} 
                  ${orderConfirmed.userAddress.cp} 
                  ${orderConfirmed.userAddress.localidad} 
                  ${orderConfirmed.userAddress.municipio} 
                  ${orderConfirmed.userAddress.state.nomEstado} 
                  ${orderConfirmed.userAddress.country.nameEn}
              `)}
            </div>
            <div style={{ marginTop: '20px' }}>
              <label>
                Entrega estimada:
              </label> {' '}
              <label className="font-weight-bold" style={{ color: 'green' }}>
                {orderConfirmed.supplier && orderConfirmed.supplier.tiempoEntregaEstandar} días hábiles
              </label>
            </div>
          </CardBody>
        </Card>
        <SummaryCard cart={cart} title="Datos del Pago" showCouponDiscount={false} />
        <Card>
          <CardBody>
            <div className="text-center">
              {
                !isEmpty(orderConfirmed) && orderConfirmed.lineItems.map(item => (
                  <div key={item.id}>
                    <div
                      className="product-image-order-confirmed"
                      style={{ marginBottom: '150px' }}
                    >
                      <img
                        src={!isEmpty(item.product.gallery) ? head(item.product.gallery).fileName : getUrlOfDefaultProductImage()}
                        alt={item.product.name}
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                    <div>
                      <label className="font-weight-bold">{item.product.name}</label>
                      {!isEmpty(item.productVariant) && (
                        <div>
                          {!isEmpty(item.productVariant.firstOption.label) && (
                            <span>{item.productVariant.firstOption.label}: <label>{item.productVariant.firstOption.value} </label></span>
                          )}
                          {!isEmpty(item.productVariant.secondOption.label) && (
                            <span> - {item.productVariant.secondOption.label}: <label>{item.productVariant.secondOption.value} </label></span>
                          )}
                          {!isEmpty(item.productVariant.thirdOption.label) && (
                            <span> - {item.productVariant.thirdOption.label}: <label>{item.productVariant.thirdOption.value}</label></span>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      Cantidad: <label className="font-weight-bold">{item.quantity}</label> -
                      Importe: <label className="font-weight-bold">
                        <CurrencyFormat
                          value={` ${Math.round(item.subtotal)}`}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                        />
                      </label>
                    </div>
                  </div>
                ))
              }
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className="text-center">
              <div style={{ marginBottom: '20px' }}>
                ¡Gracias por comprar en <label style={{ color: '#e52e6a' }}>Vendora!</label>
              </div>
              <div>
                Si tienes alguna duda o comentario sobre la transacción favor de enviar un correo a <a href={`mailto:${settings ? settings.value : ''}`}>{settings ? settings.value : ''}</a>
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
const mapStatetoProps = (state) => {
  return {
    user: state.Login.user
  }
}

export default connect(
  mapStatetoProps, {}
)(OrderConfirmedView)
